var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-lg mx-auto mt-16 text-base"},[(_vm.errors)?_c('BaseError',{attrs:{"errors":_vm.errors}}):_vm._e(),(_vm.messages)?_c('BaseInfo',{attrs:{"infos":_vm.messages}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }